import { API_CONFIG } from './apiConfig';

interface BeehiivSubscriber {
  email: string;
  name?: string;
  reactivate?: boolean;
}

export async function subscribeToNewsletter(subscriber: BeehiivSubscriber) {
  try {
    const response = await fetch('https://api.beehiiv.com/v2/subscribers', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${API_CONFIG.BEEHIIV.API_KEY}`
      },
      body: JSON.stringify({
        publication_id: API_CONFIG.BEEHIIV.PUBLICATION_ID,
        email: subscriber.email,
        name: subscriber.name,
        reactivate: subscriber.reactivate || false
      })
    });

    if (!response.ok) {
      throw new Error('Failed to subscribe');
    }

    return await response.json();
  } catch (error) {
    console.error('Error subscribing to newsletter:', error);
    throw error;
  }
}